// extracted by mini-css-extract-plugin
export var currencyInput = "_lz-1";
export var currencySymbol = "_lz-0";